import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IOnChangesObject, IScope} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {SakRessurs} from "felles/tjenester/ressurser/SakRessurs";
import {Filopplasting, SakWebRessurs} from "../../../../tjenester/ressurser/SakWebRessurs";
import {Debugger} from "debug";
import {dersomChangesInneholder} from "../../../../../felles/stoettefunk/angularHjelpemetoder";
import {kallNedgradertNg2TjenesteVedEndring, SaksdokumentDatatjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {kopierFraNg2TilAjs} from "felles-ng2/modell/ajsNg2ModellBroer";
import {Subject} from "rxjs";
import {AgendaelementId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";

const debug: Debugger = require('debug')('DokumenterKontroller');
const css = require('./dokumenter.scss');


//@todo DokumenterKontroller er saksspesifikk? sjekk dette og dokumenter
export class DokumenterKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmMoeteDokumenter', {
                bindings: {
                    sak: "<"
                },
                controller: DokumenterKontroller.forInjisering(),
                template: require('./dokumenter.html')
            })
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            SakRessurs.regNavn,
            SakWebRessurs.regNavn,
            Kontekst.regNavn,
            ng2RegNavn.SaksdokumentDatatjenesteForAjs,
            DokumenterKontroller
        ]
    }

    constructor(private $scope: IScope,
                private sakRes: SakRessurs,
                private sakWebRes: SakWebRessurs,
                private kontekst: Kontekst,
                private saksdokumentDatatjenesteForAjs: SaksdokumentDatatjenesteForAjs) {
        kallNedgradertNg2TjenesteVedEndring(
          this.$scope,
          this.vedEndringer,
          endring => endring.sak?.currentValue?.id as AgendaelementId,
          this.saksdokumentDatatjenesteForAjs.tjeneste(),
          (sakId, saksdokumentDatatjeneste) => saksdokumentDatatjeneste.finnTilknyttetSakFraLokallager(sakId)
        ).subscribe(dokumenter => this.dokumenter = kopierFraNg2TilAjs(dokumenter));
    }

    sak: l.AgendaelementModell; //settes via bindings/$onChanges

    dokumenter: l.SaksdokumentModell[];
    redigeringMulig = false;
    dokumentrekkefoelgeEndret = false;

    private previewModusAktivert = false;
    private dokumenterIPreviewModus:{[dokumentId:string]: boolean} = {};
    private orginalDokumentrekkefølge: string[];
    private vedEndringer = new Subject<IOnChangesObject>();

    previewModusAktivertFor(dokument:l.SaksdokumentModell, aktivert:boolean){
        this.dokumenterIPreviewModus[dokument.id] = aktivert;
        this.previewModusAktivert = this.dokumenter.some(d => this.erPreviewModusAktivertFor(d));
    }

    erPreviewModusAktivertFor(dokument:l.SaksdokumentModell){
        return this.dokumenterIPreviewModus[dokument.id] === true;
    }

    registrerNyVersjon(dokument: l.SaksdokumentModell, filer: File[]) {
        this.sakWebRes.opprettNyDokumentVersjon(
            this.sak.id,
            dokument.dokumentId,
            filer[0],
            nyttDokument => {});
    }

    slett(dokument: l.SaksdokumentModell) {
        this.saksdokumentDatatjenesteForAjs.tjeneste().then(saksdokumentDatatjeneste =>
            saksdokumentDatatjeneste.slettSaksdokument(this.sak.id, dokument.dokumentId));
    }

    /** Forhindrer at dokumentsrekkefølge kan redigeres når annet skjema er aktivt,
     * eller dersom bruker ikke har tilgang eller møtet er låst*/
    erDokumentrekkefoelgeRedigeringDeaktivert() {
        return !this.redigeringMulig || this.previewModusAktivert; /* || this.menyTjeneste.erDeaktivert() ;*/
    }

    /** konfig for dokumentsliste ng-sortable */
    ngSortableKonfigForDokumentrekkefoelge() {
        return {
            dragStart: () => {
                console.log('# DRA START');
                //sett orginal dokumentsrekkefølge - blir ikke gjort i initData() da initData() kan bli kalt pga modelloppdateringer mens man endrer rekkefølge
                if (!this.orginalDokumentrekkefølge)
                    this.orginalDokumentrekkefølge = this.dokumentIder();
            },
            orderChanged: (event) => {
                this.dokumentrekkefoelgeEndret = !_.isEqual(this.dokumentIder(), this.orginalDokumentrekkefølge);
                console.log('# REKKF ENDR', this.dokumentrekkefoelgeEndret, this.dokumentIder(), this.orginalDokumentrekkefølge);
            },
            // sørger for at dokument som flyttes opptrer som barn av .sls-dokumenter-kontainer i dom-treet
            // i stendenfor barn av body som er default
            // betinger containerPositioning:relative
            containment: '.sls-dokumenter-kontainer',
            containerPositioning: 'relative'
        };
    }

    lagreNyDokumentrekkefoelge() {
        this.sakRes.oppdaterDokumentrekkefølge(this.sak.id, this.dokumentIder()).$promise
            .then((sak) => {
                this.dokumentrekkefoelgeEndret = false;
                this.orginalDokumentrekkefølge = null;
            })
    }

    avbrytNyDokumentrekkefoelge() {
        this.dokumenter = _(this.dokumenter).sortBy(dokument => this.orginalDokumentrekkefølge.indexOf(dokument.dokumentId)).value();
        this.dokumentrekkefoelgeEndret = false;
        this.orginalDokumentrekkefølge = null;
    }

    paagaaendeOpplastinger() {
        if (!this.sak) return [];
        return this.sakWebRes.finnOpplastinger(this.sak.id);
    }

    avbrytOpplasting(opplasting: Filopplasting) {
        opplasting.avbryt();
    }

    $onChanges(changes: IOnChangesObject) {
        this.vedEndringer.next(changes);
        dersomChangesInneholder(changes, 'sak', (sak: l.AgendaelementModell) => {
            this.redigeringMulig = this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.sak.eiendeGruppeId) && !this.sak.moete.laastForRedigering;
        });
    }

    //private hjelpemetoder

    private dokumentIder(): string[] {
        return this.dokumenter.map(d => d.dokumentId);
    }

}


